var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-string-create',{attrs:{"client-id":null,"back-route":{ name: 'system-content-strings' }}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/content/strings/create.vue?vue&type=template&id=702cd97e
// module id = UUGI
// module chunks = 0